import React from 'react';
import { InputNumber, Space, Typography } from 'antd';
import {
  MEASUREMENT_DIMENSION_LABELS,
  measurementDimensionKeys,
  type MeasurementDimensionKey,
  type MeasurementDims,
  type MeasurementType,
} from '@/utils/inventory/measurementQuantity';

const { Text } = Typography;

const SHORT_LABEL: Record<MeasurementDimensionKey, string> = {
  length_mm: 'L',
  width_mm: 'W',
  height_mm: 'H',
};

export interface MeasurementDimensionInputsProps {
  type: MeasurementType | null | undefined;
  value: MeasurementDims | null | undefined;
  onChange: (key: MeasurementDimensionKey, value: number | null) => void;
  disabled?: boolean;
}

/** L / W / H (mm) inputs driven by the item Measurement Type; renders '—' for quantity-only items. */
export const MeasurementDimensionInputs: React.FC<MeasurementDimensionInputsProps> = ({
  type,
  value,
  onChange,
  disabled,
}) => {
  const keys = measurementDimensionKeys(type);
  if (!keys.length) return <Text type="secondary">—</Text>;
  return (
    <Space direction="vertical" size={2} style={{ width: '100%' }}>
      {keys.map((k) => {
        const raw = value?.[k];
        const num = raw == null || raw === '' ? undefined : Number(raw);
        return (
          <InputNumber
            key={k}
            size="small"
            min={0}
            disabled={disabled}
            placeholder={MEASUREMENT_DIMENSION_LABELS[k]}
            addonBefore={SHORT_LABEL[k]}
            value={num}
            onChange={(v) => onChange(k, v == null ? null : Number(v))}
            style={{ width: '100%' }}
          />
        );
      })}
    </Space>
  );
};
